import { StaffUserSession } from '@/types/staffSession';

export const setLocalStorageSession = (staffSession: StaffUserSession, host: string) => {
  let hostUsers;
  const storedUser = localStorage.getItem('dugoutCurrentUser');

  if (storedUser) {
    hostUsers = JSON.parse(storedUser);
    hostUsers[host] = staffSession;
  } else {
    hostUsers = { [host]: staffSession };
  }
  localStorage.setItem('dugoutCurrentUser', JSON.stringify(hostUsers));
};

export const removeLocalStorageSession = (host: string) => {
  const storedUser = localStorage.getItem('dugoutCurrentUser');
  if (storedUser) {
    const hostUsers = JSON.parse(storedUser);
    delete hostUsers[host];
    localStorage.setItem('dugoutCurrentUser', JSON.stringify(hostUsers));
  }
};
